<template>
  <div>
    <el-card class="box-card  min-h-screen">
      <div class="m-auto  text-center text-3xl">
        编辑文章
      </div>
      <div class="mt-6">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm w-2/3"
        >
          <el-form-item label="文章标题" prop="news_title">
            <el-input v-model="ruleForm.news_title"></el-input>
          </el-form-item>
          <el-form-item label="文章类型" prop="news_type">
            <el-input v-model="ruleForm.news_type"></el-input>
          </el-form-item>
          <el-form-item label="文章内容">
            <quill-editor
              v-model="ruleForm.news_content"
              ref="myQuillEditor"
              :options="editorOption"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
              @ready="onEditorReady($event)"
              @change="onEditorChange($event)"
            ></quill-editor>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')"
              >编辑</el-button>

          </el-form-item>

        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import axios from "axios";
//引入Vue的ueditor的资源
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
// import quillConfig from '../../common/js/quill-config';
export default {
  components: {
    quillEditor
  },
  data() {
    return {
      ruleForm: {
        news_title: "",
        add_time: "",
        news_type: "",
        news_content: ""
      },
      news_id:'',
      description: "",
      editorOption: {
        // 编辑器配置
        placeholder: "请在这里输入",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], //加粗，斜体，下划线，删除线
            ["blockquote", "code-block"], //引用，代码块
            [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
            [{ list: "ordered" }, { list: "bullet" }], //列表
            [{ script: "sub" }, { script: "super" }], // 上下标
            [{ indent: "-1" }, { indent: "+1" }], // 缩进
            [{ direction: "rtl" }], // 文本方向
            [{ size: ["small", false, "large", "huge"] }], // 字体大小
            [{ header: [1, 2, 3, 4, 5, 6, false] }], //几级标题
            [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
            [{ font: [] }], //字体
            [{ align: [] }], //对齐方式
            ["clean"], //清除字体样式
            ["image"] //上传图片、上传视频 ['image', 'video']
          ]
        }
      }
    };
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  mounted(){
    const news_id = this.$route.query.news_id;
    this.news_id = news_id;
    this.getNews(news_id)
  },
  methods: {
    getNews(id) {
      axios.get('/selectNews_id/'+id).then(({data})=>{
       if(data.code == 200) {
        this.ruleForm = data.data;
       }
      })
    },
    onEditorBlur(quill) {

    },
    onEditorFocus(quill) {

    },
    onEditorReady(quill) {

    },
    onEditorChange({ quill, html, text }) {

      this.ruleForm.news_content = html;
    },
    // 转码
    escapeStringHTML(content) {
      content = content.replace(/&lt;/g, "<");
      content = content.replace(/&gt;/g, ">");
      return content;
    },
    submitForm(formName) {


        this.$refs[formName].validate((valid) => {
          if (valid) {
            axios.post('/updateNews/'+this.news_id, this.ruleForm).then(({data})=>{
              if(data.code == 200) {
                this.$message({
                  type:'success',
                  message: data.msg
                })
                this.$router.push({
                path: "/newsList"
              })
              }else{
                this.$message({
                  type:'error',
                  message: data.msg
                })
              }
            })




          } else {

            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.description=''
      }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/news/updateNews.vue